
import { Component, Prop, Vue } from 'vue-property-decorator'
import eventBus from '@/plugins/eventBus'

@Component
export default class SubCategoryHeader extends Vue {
  show: boolean = false
  @Prop()
  categories: any

  selectCategory(category: any, event: any) {
    event.stopPropagation()
    this.show = false
    eventBus.$emit('categories:selected', category.id)
  }

  mounted() {
    eventBus.$on('categories:showMore', () => {
      this.show = !this.show
    })
  }
}
